import * as ACL from 'domain/restriction';
import { isFirefox } from 'lib/systemHelpers/browserHelpers';

export const rights = (r?: unknown) => ({
  isAuthorized: () => ACL.check(ACL.IS_AUTHORIZED, r),
  payIsOwner: () => ACL.check(ACL.PAY_IS_OWNER, r),
  payIsController: () => ACL.check(ACL.PAY_IS_CONTROLLER, r),
  payIsApprover: () => ACL.check(ACL.PAY_IS_APPROVER, r),
});

export const localRights = ACL.advancedRights(rights);

export const items = [
  {
    id: 'open',
    title: 'Open',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
  },
  {
    id: 'preview',
    title: 'Preview',
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    separator: true,
  },
  {
    id: 'startPaymentProcess',
    title: 'Start payment process',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'sendToApproval',
    title: 'Send to Approval',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
  },
  {
    id: 'approve',
    title: 'Approve',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(
      localRights.paramsName.payIsOwner,
      localRights.paramsName.payIsController,
      localRights.paramsName.payIsApprover,
    ),
  },
  {
    id: 'resetApprovalFlow',
    title: 'Reset approval flow',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
  },
  {
    id: 'pay',
    title: 'Pay',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
  },
  {
    id: 'sendByEmail',
    title: 'Share via email',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    comingSoon: true,
  },
  {
    id: 'printDocument',
    title: 'Print document',
    disabled: isFirefox,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    comingSoon: true,
  },
  {
    id: 'downloadDocument',
    title: 'Download document',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    separator: true,
    comingSoon: true,
  },
  {
    id: 'saveForLater',
    title: 'Save for later',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'archive',
    title: 'Archive',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
  {
    id: 'unarchive',
    title: 'Unarchive',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
  },
];

export const filteredItem = (p: { restriction: unknown }) => {
  const lr = localRights.restriction(p.restriction);

  return items.filter(ACL.arrayFilter(lr)).map(ACL.arrayMap(lr, 'disabled'));
};
